export const translation = {
    "en": () => import("./en.json"),
    "ar": () => import("./ar.json"),
    "ru": () => import("./ru.json")
};

export const DEFAULT_LANGUAGE = "en";

export const rtlLangs = ["ar"];